import { HttpEventType } from '@angular/common/http';
import { AfterViewInit, Component, ComponentFactoryResolver, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { DxChartComponent, DxPieChartComponent } from 'devextreme-angular';
import { DxoExportComponent, DxoPermissionsComponent } from 'devextreme-angular/ui/nested';
import { data } from 'jquery';
import { AnteprimaPDfComponent } from '../anteprima-pdf/anteprima-pdf.component';
import { NicaChartMakerFormComponent } from '../nica-chart-maker-form/nica-chart-maker-form.component';
import { IChartContent } from './IChartContent';




@Component({
  selector: 'app-nica-chart-maker',
  templateUrl: './nica-chart-maker.component.html',
  styleUrls: ['./nica-chart-maker.component.css','../../../components/nica-anagrafica/nica-anagrafica.component.css',"../../../components/nica-anagrafica/nica-anagrafica.component.style.css","../../../components/nica-anagrafica/nica-anagrafica-template.css","../../../components/shared/anteprima-pdf/anteprima-pdf.component.css"],
  preserveWhitespaces: true,
})



export class NicaChartMakerComponent implements OnInit,AfterViewInit {



  //@ViewChild('tortaRef',{read:true,static:false}) tortaRef : ElementRef<any>;

  
  @ViewChild('anteprimaPDF',{static:false,read:ViewContainerRef}) anteprimaPDF : ViewContainerRef;
  @ViewChild(DxChartComponent , { static: false }) grafico: DxChartComponent;
  @ViewChild(DxPieChartComponent,{ static: false}) graficoATorta : DxPieChartComponent; //Il grafico a torta è caratterizzato da una apposita classe per questo uso di nuovo il decorator @ViewChild
  
  @ViewChild('containerDinamico',{static:false,read:ViewContainerRef}) containerDinamico : ViewContainerRef;
  @ViewChild(NicaChartMakerFormComponent,{static:false}) chartForm : NicaChartMakerFormComponent;

  jsonGrafico?:IChartContent;
  dataSourceTorta:any[];
  dataSourceBarre:any[];

  

  mostraPopupFormStatistiche:boolean=false;
  mostraPopupAnteprima:boolean=false;

  itemsSelectBox:any[]=[
    {
      text:'Torta',
      imgSrc:'https://cdn-icons-png.flaticon.com/512/167/167485.png'
    },
    {
      text:'Barre',
      imgSrc:'https://cdn-icons-png.flaticon.com/512/436/436320.png'
    },
    {
      text:'Linee',
      imgSrc:'https://cdn-icons-png.flaticon.com/512/7495/7495244.png'
    }

  ];

  palettes:string[]=[
    'Ocean', 'Bright' , 'Harmony Light' , 'Pastel' , 'Soft' , 'Soft Pastel' , 'Vintage' , 'Violet' , 'Carmine' , 'Dark Moon' , 'Dark Violet' , 'Green Mist' , 'Soft Blue' , 'Material' , 'Office'
  ];

  paletteSelezionata?:string;

  tipoGrafico?:'torta'|'barre'|'linee';

  gruppiGrafici:string[] = ['Tutti'];
  
  icona="bi bi-pie-chart-fill";
  //"glyphicon glyphicon icon-annulla-form";
  buttoniForm = [
    {
      location: "after",
      widget: "dxButton",
      locateInMenu: "never",
      useSubmitBehavior: true,
      options:
      {
        stylingMode: "text",
        text: 'Genera Grafico',
        hint: "Genera a video il grafico con i filtri applicati",
        icon: this.icona,
        visible: true,
        onClick: ($event) => {

          
          this.chartForm.emettiEventoPulsante(undefined);

        }
      }


    }
  ];

  bottoniBack = [
    {
      location: "after",
      widget: "dxButton",
      locateInMenu: "never",
      useSubmitBehavior: true,
      options:
      {
        stylingMode: "text",
        text: 'Torna indietro',
        hint: "Torna indietro",
        icon: "glyphicon glyphicon icon-annulla-form",
        visible: true,
        onClick: ($event) => {

          
          this.onClickTornaAlForm();

        }
      }


    }
  ];

  @Input() arrayGraficiJson:IChartContent[]=[];
  /*[
    {
      //tipoGrafico:'torta',
      titolo:'Distinta CER 2017-2018-2019',
      dati:[{
        gruppo:'2017',
        series:[
          {
          name:'010411',
          tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
          value:20
          },
          {
            name:'010412',
            tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
            value: 35
    
          },
          {
            name:'010500',
            tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
            value:45
          }
        ]
        
      },{
        gruppo:'2018',
        series:[
          {
          name:'010411',
          tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
          value:50
          },
          {
            name:'010412',
            tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
            value: 30
    
          },
          {
            name:'010500',
            tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
            value:20
          }
        ]
        
      },
      {
          gruppo:'2019',
          series:[
            {
            name:'010411',
            tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
            value:45
            },
            {
              name:'010412',
              tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
              value:25
      
            },
            {
              name:'010500',
              tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
              value:30
            }
          ]
          
          },
        ]
      },
      {
        
        titolo:'Distinta CER 2020-2021-2022',
        dati:[{
          gruppo:'2020',
          series:[
            {
            name:'010411',
            tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
            value:20
            },
            {
              name:'010412',
              tooltip:'RIFIUTI DELLA LAVORAZIONE DI POTASSA E SALGEMMA',
              value: 10
      
            },
            {
              name:'010500',
              tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
              value:70
            }
          ]
          
        },
        {
            gruppo:'2021',
            series:[
              {
              name:'010411',
              tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
              value:40
              },
              {
                name:'010412',
                tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
                value:40
        
              },
              {
                name:'010500',
                tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
                value:20
              }
            ]
            
            },
            {
              gruppo:'2022',
              series:[
                {
                name:'010411',
                tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
                value:75
                },
                {
                  name:'010412',
                  tooltip:'STERILI E ALTRI RESIDUI DEL LAVAGGIO E DELLA PULITURA DI MINERALI',
                  value:20
          
                },
                {
                  name:'010500',
                  tooltip:'FANGHI DI PERFORAZIONE ED ALTRI RIFIUTI DI PERFORAZIONE',
                  value:5
                }
              ]
              
              }
          ]
        }




  ];*/
  
  arrayGraficiJsonTitoli = this.arrayGraficiJson.map(json=>json.titolo)
  @Input() valorePerTooltip:string="";

  tooltip(arg){ //`${arg.seriesName != 'Series 1' ? arg.seriesName : arg.point.data.gruppo} -

    //console.log(arg);
    return { text:`<strong>${arg.argumentText}</strong><br> valore : ${arg.valueText} ${this.valorePerTooltip}<br>${(arg.point.data['tooltip'] ? arg.point.data['tooltip'] : '')}` };
  }

  constructor(private resolver:ComponentFactoryResolver,private router:Router){ 

    setTimeout(
      ()=>{
        this.chartForm.emettiJsonGrafico.subscribe(
          (json:IChartContent)=>{
    
            //console.log('amongus',json);
    
            this.arrayGraficiJson.push(json);
    
            this.jsonGrafico = this.arrayGraficiJson[0];
    
            
           
              if(this.chartForm.valore.toLowerCase().includes('kg'))
                this.valorePerTooltip = 'Kg.';
              
              if(this.chartForm.valore.toLowerCase().includes('mc'))
                this.valorePerTooltip = 'Mc.';

              if(this.chartForm.valore.toLowerCase().includes('numero'))
                this.valorePerTooltip = 'Movimenti';  

                this.tooltip = this.tooltip.bind(this);
           
              this.tipoGrafico= 'barre' //this.jsonGrafico.tipoGrafico;
           
              if(!this.jsonGrafico){
       
                return;
              }

            this.costruisciGrafico();
          }
        );
      },500
    )
    
  

  }
  ngAfterViewInit(): void {
    
  
  }


  
  onValueChangedCambiaTipoGrafico(evt:any){
    
    this.tipoGrafico = ((evt.value.text as string).toLowerCase() as any);

    this.costruisciGrafico();
    
  }

  onValueChangedCambiaPalette(evt:any){

    this.paletteSelezionata = evt.value;
    //this.costruisciGrafico();
  }

  onValueChangedCambiaGruppo(evt:any){

    let gruppo : string = evt.value;

    
    if(gruppo.toLowerCase() == 'tutti')
      this.costruisciGrafico();
    else  
    this.costruisciGrafico(gruppo);


  }

  onValueChangedCambiaTitolo(evt:any){
    
    
    let valore : string = ((evt.element as HTMLElement).children.item(0).children.item(0).children.item(0) as HTMLInputElement).value    

    //console.log(evt);

    //console.log(valore);

    for(let i = 0; i< this.arrayGraficiJson.length; i++){

      if(this.jsonGrafico.titolo == this.arrayGraficiJson[i].titolo){
        this.arrayGraficiJsonTitoli[i] = valore;
        this.arrayGraficiJson[i].titolo = valore;
        
        break;
      }

    }
    
    /*
    for(let i = 0; i< this.arrayGraficiJsonTitoli.length; i++){

      if(this.jsonGrafico.titolo == this.arrayGraficiJsonTitoli[i]){

        this.arrayGraficiJsonTitoli[i] = valore;

        break;
      }

    }
    */

    this.jsonGrafico.titolo = valore;
  }


  onValueChangedCambiaJson(evt:any){

    let titolo : string = evt.value;


    //this.jsonGrafico = evt.itemData;

    let jsonSelezionato = this.arrayGraficiJson.find(
      (json)=>{
        return json.titolo == titolo;
      }
    );

    this.jsonGrafico = jsonSelezionato;

   
    this.costruisciGrafico();
  }

  costruisciGrafico(filtroGruppo?:string){


    if(!this.jsonGrafico.dati)
      return;

    if(!this.paletteSelezionata)
      this.paletteSelezionata = this.palettes[0];


    
    this.gruppiGrafici = ['Tutti'].concat(this.jsonGrafico.dati.map(
      dato=>dato.gruppo
    ));
  

    


    switch(this.tipoGrafico.toLowerCase()){

      case 'torta':{

        this.dataSourceTorta=[];

        if(filtroGruppo){
          let dato = this.jsonGrafico.dati.find(
            (dato)=>{
              return dato.gruppo == filtroGruppo
            }
          );

          for(let serie of dato.series){
    
            
            serie.name = serie.name.charAt(0).toUpperCase()+serie.name.substring(1,serie.name.length);
            serie['tooltip'] = serie.tooltip;
            serie['gruppo'] = dato.gruppo;
    
           
            this.dataSourceTorta.push(serie);
    
    
          }

        }
        else
         for(let dato of this.jsonGrafico.dati){
          
          
          for(let serie of dato.series){
    
            
            serie.name = serie.name.charAt(0).toUpperCase()+serie.name.substring(1,serie.name.length);
            serie['tooltip'] = serie.tooltip;
            serie['gruppo'] = dato.gruppo;
    
           
            this.dataSourceTorta.push(serie);
    
    
          }
    
        }
      }break;

 
      case 'barre':
      case 'linee': { 

        this.dataSourceBarre=[];

        for(let dato of this.jsonGrafico.dati){
    
          let obj = {};
    
          obj['gruppo'] = dato.gruppo;
          //obj['tooltip'] = dato.tooltip;
    
          for(let serie of dato.series){
    
         
          
            
            obj[serie.name.charAt(0).toUpperCase()+serie.name.slice(1)] = serie.value;
            obj["tooltip"]=serie.tooltip;
    
          
    
          }
    
        
    
          this.dataSourceBarre.push(obj);
    
    
        
        }


        console.warn(this.dataSourceBarre);

        if(this.tipoGrafico == 'linee'){

        }

      }break;

     
    
    }
    
    //console.log(this.dataSourceBarre);
  }

  ngOnInit() {


    
    /*
    this.mostraPopupFormStatistiche=true;

    Quando si creava con popup ma va contro le convenzioni di proggetto

    const factory = this.resolver.resolveComponentFactory(NicaChartMakerFormComponent);

    setTimeout(()=>{

      this.containerDinamico.clear();


      let istanziatore = this.containerDinamico.createComponent(factory,0);

      istanziatore.instance.ngOnInit();

      istanziatore.instance.emettiChiusuraPopup.subscribe(
        (valore:boolean)=>{
          if(valore == true){

            this.mostraPopupFormStatistiche = false;
          }
        }
      )
      
    },500);
   */

    //console.log('ciaooo');

    //this.jsonGrafico = this.arrayGraficiJson[0];


  }

  legendaTorta(args){

    //console.log(args)

    for(let arg of args){
      //console.log(arg.points[0].data.gruppo)

      arg.text = arg.points[0].data.gruppo + '\n' + arg.text;
    }


    return args;
  }

  
/*
  stileGrafico(){

    if(this.jsonGrafico.opzioniStile.altezza && this.jsonGrafico.opzioniStile.larghezza)
      return {'width':this.jsonGrafico.opzioniStile.larghezza,'height':this.jsonGrafico.opzioniStile.altezza}
    
    else if(this.jsonGrafico.opzioniStile.altezza)
      return {'width':this.jsonGrafico.opzioniStile.larghezza,'height':'500px'}

    else if(this.jsonGrafico.opzioniStile.larghezza)
      return {'width':'500px','height':this.jsonGrafico.opzioniStile.altezza}
  }
*/

 

  onClickStampa(evt:any,formato:string){

    //console.log(evt);  

    evt.instance.exportTo(this.jsonGrafico.titolo,formato); //Questo passaggio verrà poi intercettato da onSalvataggioGrafico

    
    
    
  }

  onSalvataggioGrafico(evt){

    //console.log(evt);
    
    
    switch(evt.format.toLowerCase()){
  
      case 'pdf':{
  
        evt.cancel=true; //Evito che il file venga scaricato automaticamente
  
        this.mostraPopupAnteprima=true;  
  
        const factory = this.resolver.resolveComponentFactory(AnteprimaPDfComponent);

        setTimeout(() => {
          
          this.anteprimaPDF.clear();
          
          let instanza=this.anteprimaPDF.createComponent(factory,0);
          
          instanza.instance.isFile=true;
          
          //console.log(evt);
          
          instanza.instance.$title = evt.fileName;

          instanza.instance.fileData = evt.data;
          
          instanza.instance.emettiChiusura.subscribe
          ((x)=>{
            if(x){
              this.anteprimaPDF.clear();
              this.mostraPopupAnteprima=false;
            }
          });
          
          
    
        
        }, 500);
      }
      break;
      default:{ //Tutti gli altri formati
  
        return;
  
      }
  
  
  
    }
    
  }

  chiudiPopupAnteprima(evt){
    this.mostraPopupAnteprima=false;
    this.anteprimaPDF.clear();
  }

  onClickEsportaInCSV(evt:any){

      if(evt instanceof DxChartComponent){

        const dati = (evt.dataSource) as any[];
        let intestazione:string[]=[];
        
        for(let key of Object.keys(dati[0])){
          //console.log(key);
          if(key.toLowerCase() !== 'tooltip'){
            intestazione.push(key);
          }
        }
      
        let matrice:string[][]=[intestazione];
      
      
          for(let dato of dati){
          
            let temp = [];
          
            for(let entry of Object.entries(dato)){

                //console.log(entry[1]);
                if(entry[0].toLowerCase() !== 'tooltip'){
                  temp.push(entry[1].toString());
                }
              
            }
          

            matrice.push(temp);
          }
        
        
        //console.table(matrice)

        const stringaCSV :string= this.costruisciStringaCSV(matrice);

        this.scaricaFileCSV(stringaCSV);


     }
     else if(evt instanceof DxPieChartComponent){
       



        const dati = (evt.dataSource as any[]);

        //console.log(dati);

        let intestazione:string[]=['gruppo'];

        for(let dato of this.jsonGrafico.dati.slice(0,1)){

          for(let serie of dato.series){
            
            intestazione.push(serie.name);
          }

        }

        let matrice : string[][]=[intestazione];

        for(let dato of this.jsonGrafico.dati){
          
          let array : string[]=[dato.gruppo];

          for(let serie of dato.series){
            array.push(serie.value.toString());
          }

          matrice.push(array);
        }

        //console.log(intestazione);
        //console.log(matrice);

        const stringaCSV :string= this.costruisciStringaCSV(matrice);

        this.scaricaFileCSV(stringaCSV);
        
     }

  }

  costruisciStringaCSV(matrice:string[][]):string{

    let dataCsv : string = "";

    for(let array of matrice){

      for(let stringa of array){

        dataCsv += `${stringa},`;
      }

      dataCsv = `${dataCsv.substring(0,dataCsv.length-1).concat('\n')}`;
    }

    return dataCsv;

  }

  //Metodo che prende dall'esterno la stringa csv e ne scarica il relativo file.csv
  scaricaFileCSV(dataCSV:string){

    let csvBlob = new Blob([dataCSV],{type: 'text/csv'});

    let linkPerDownload = document.createElement("a");

    linkPerDownload.download = this.jsonGrafico.titolo;

    linkPerDownload.href = URL.createObjectURL(csvBlob);

    linkPerDownload.style.display = 'none';

    linkPerDownload.click();
  }

  onClickTornaAlForm(){
    this.jsonGrafico=undefined;
    this.arrayGraficiJson=[];
    this.arrayGraficiJsonTitoli=[];

    setTimeout(
      ()=>{
        this.chartForm.emettiJsonGrafico.subscribe(
          (json:IChartContent)=>{
    
            //console.log('amongus',json);
    
            this.arrayGraficiJson.push(json);
    
            this.jsonGrafico = this.arrayGraficiJson[0];
    
            
            this.tipoGrafico= 'barre' //this.jsonGrafico.tipoGrafico;
           
            if(this.chartForm.valore.toLowerCase().includes('kg'))
                this.valorePerTooltip = 'Kg.';
              
              if(this.chartForm.valore.toLowerCase().includes('mc'))
                this.valorePerTooltip = 'Mc.';

              if(this.chartForm.valore.toLowerCase().includes('numero'))
                this.valorePerTooltip = 'Movimenti';  


            this.costruisciGrafico();
          }
        );

      },500
    )
    
  }


  chiudiPopupModifica(evt:any){

    this.mostraPopupFormStatistiche=false;
  }

  
}
